import { CategoryDto } from '../../commonTypes/documents.types';
import { useTranslation } from '../../hooks/useTranslation';
import { useNavigate } from 'react-router';
import { useResizeListener } from '../../hooks/windowEvents/useResizeListener';
import { Button, MixerLoader } from '../../components/Common';
import { Card } from './Card';
import { useHttpDeleteCategory, useHttpGetCategories } from '../../hooks';
import { Modal, YesNo } from '../../components/Common';
import { useEffect, useRef, useState } from 'react';

interface ICategory {
    categories: { category: CategoryDto; documentCount: number }[];
}

const DocumentCategoriesSafetyWrapper = () => {
    const { areCategoriesReady, categories } = useHttpGetCategories();
    if (!areCategoriesReady) return <MixerLoader position="centerOnParent" />;
    return <DocumentCategories categories={categories} />;
};

const DocumentCategories = ({ categories }: ICategory) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const categoryToDeleteId = useRef<string>();
    const { exec } = useHttpDeleteCategory();
    const [categoriesWithCountState, setCategoriesWithCountState] = useState<{ category: CategoryDto; documentCount: number }[]>([]);

    useEffect(() => {
        setCategoriesWithCountState(categories);
    }, [categories]);

    const openDeleteModal = (id: string) => {
        categoryToDeleteId.current = id;
        setIsDeleteModalOpen(true);
    };

    const deleteCategory = (id?: string) => {
        if (id) exec(id);
        setCategoriesWithCountState(prev => prev.filter(cat => cat.category.id !== id));
        setIsDeleteModalOpen(false);
    };

    const { isXSmall, isSmall, isMedium } = useResizeListener();

    const isMobile = isXSmall || isSmall || isMedium;

    return (
        <div className="documents">
            {!isMobile && (
                <div className="documents__header">
                    <h2>{t('documents.documentsManagment')}</h2>
                    <Button text={t('createCategory.pageTitle.addCategory')} onClick={() => navigate('/create-category')} />
                </div>
            )}
            <div className="documents__main">
                <h4>{t('documents.yourCategories')}</h4>
                <div className="documents__list">
                    {categoriesWithCountState.map(cat => (
                        <Card key={cat.category.id} category={cat.category} onDelete={openDeleteModal} documentCount={cat.documentCount} />
                    ))}
                    {isMobile && <Button text={t('createCategory.pageTitle.addCategory')} onClick={() => navigate('/create-category')} />}
                </div>
            </div>
            <Modal isVisible={isDeleteModalOpen} closeModal={() => setIsDeleteModalOpen(false)}>
                <YesNo
                    onNo={() => setIsDeleteModalOpen(false)}
                    onYes={() => deleteCategory(categoryToDeleteId.current)}
                    title={t('deleteCategory.deleteTitle')}
                    description={t('deleteCategory.deleteDescription')}
                />
            </Modal>
        </div>
    );
};

export default DocumentCategoriesSafetyWrapper;
